import React, { useContext, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { MainContext } from "../context/context";
import useSound from "use-sound";
import { useMediaQuery } from "react-responsive";

import "./NavBar.scss";
import ConnectWallet from "../../components/ConnectWallet/ConnectWallet";
import back from "../../assets/media/icons/Back.png"
import x from "../../assets/svg/X.png"
import discord from "../../assets/svg/Discord.png"
import team from "../../assets/svg/Team.png"
import allowlist from "../../assets/svg/Allowlist.png"
import ecosystem from "../../assets/svg/Ecosystem.png"
import connect from "../../assets/svg/Wallet.png"
import volumeOn from "../../assets/svg/MusicOn.png"
import logo from "../../assets/svg/Logo (1).png"
import volumeOff from "../../assets/svg/MusicOff.png"
// Assets
import LogoMain from "../../assets/media/images/bearbull.png";
import clickSound from "../../assets/sound/onClickSound.wav";
import { ReactComponent as CloseIcon } from "../../assets/media/icons/CancelIcon.svg";
import { ReactComponent as HamburgerIcon } from "../../assets/media/icons/HamburgerMenu.svg";
import { ReactComponent as VolumeOn } from "../../assets/media/icons/volumeOn.svg";
import { ReactComponent as VolumeOff } from "../../assets/media/icons/volumeOff.svg";
import lock from "../../assets/svg/Lock.png"
const NavBar = () => {
  const isTablet = useMediaQuery({ query: "(max-width: 950px)" });
  const [playClickSound] = useSound(clickSound, { volume: 0.325 });
  const { showNavBar, isSoundEnabled, setIsSoundEnabled } =
    useContext(MainContext);
  const [isMobileSideMenuOpen, setIsMobileSideMenuOpen] = useState(false);
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);
  const [hovered1, setHovered1] = useState(false);
  const [hovered2, setHovered2] = useState(false);
  return (
    <div className="header-top-wrapper">
    <header className="header">
<div className="header-left">
<div
className="icon-button"
onClick={() => navigate("/")}

>

  <img
    src={back}
    alt="back"

  />



</div>
<div className="icon-button"  
         >
<img src={x} alt="X"  onClick={() =>
            window.open("https://x.com/fortunefoes", "_blank")
          }/>
</div>
<div className="icon-button">
<img src={discord} alt="Discord"    onClick={() =>
            window.open("Discord.gg/Foes", "_blank")
          }/>
</div>
<div
className="icon-button"
onMouseEnter={() => setHovered2(true)}
onMouseLeave={() => setHovered2(false)}
>

  <img
    src={allowlist}
    alt="Team"
    style={{
      position: 'absolute',

      opacity: hovered2 ? 0 : 0.9,
      transition: 'opacity 1s ease',
      pointerEvents: 'none',
    }}
  />
  <img
    src={lock}
    alt="Locked"
    style={{
      position: 'relative',
      opacity: hovered2 ? 0.9 : 0,
      transition: 'opacity 1s ease',
      pointerEvents: 'none',
    }}
  />

<span className="mt-1 text-sm">ALLOWLIST</span>
</div> 
<div
className="icon-button"
onMouseEnter={() => setHovered(true)}
onMouseLeave={() => setHovered(false)}
>

  <img
    src={ecosystem}
    alt="Team"
    style={{
      position: 'absolute',

      opacity: hovered ? 0 : 0.9,
      transition: 'opacity 1s ease',
      pointerEvents: 'none',
    }}
  />
  <img
    src={lock}
    alt="Locked"
    style={{
      position: 'relative',
      opacity: hovered ? 0.9 : 0,
      transition: 'opacity 1s ease',
      pointerEvents: 'none',
    }}
  />

<span className="mt-1 text-sm">ECOSYSTEM</span>
</div>

<div
className="icon-button"
onMouseEnter={() => setHovered1(true)}
onMouseLeave={() => setHovered1(false)}
>

  <img
    src={team}
    alt="Team"
    style={{
      position: 'absolute',

      opacity: hovered1 ? 0 : 0.9,
      transition: 'opacity 1s ease',
      pointerEvents: 'none',
    }}
  />
  <img
    src={lock}
    alt="Locked"
    style={{
      position: 'relative',
      opacity: hovered1 ? 0.9 : 0,
      transition: 'opacity 1s ease',
      pointerEvents: 'none',
    }}
  />

<span className="mt-1 text-sm">TEAM</span>
</div>



</div>
  <div className="header-center">
<div className="center-content ">
<img src={logo} alt="Team" onClick={() => navigate("/")} style={{ width: "80%" }} />
</div>
</div>
  <div className="header-right">
    <div className="icon-button-right"  onClick={() => {
            setIsSoundEnabled(!isSoundEnabled);
          }}>
    {isSoundEnabled ?   <img src={volumeOn}  alt="Music On" /> :  <img src={volumeOff}  alt="Music On" /> }
    </div>
    <ConnectWallet />
  </div>
</header>
      <div className="buttons-wrapper">
    
  

        {/* TODO: UNCOMMENT THIS */}
        {/* <button
          onClick={() =>
            window.open("https://dev.bears-btc-sim.pages.dev/", "_blank")
          }
          className="game-btn bear-bull-btn"
        >
          ETH SIM
        </button>
        <button
          onClick={() =>
            window.open("https://barbearians-pl.pages.dev", "_blank")
          }
          className="game-btn bear-bull-btn"
        >
          PNL
        </button> */}
      </div>
     { /*<div className="choose-your-side-container">
        <div className="choose-your-side-wrapper">
          <p className="choose-your-side-text">CHOOSE YOUR SIDE</p>
          <ChooseYourSide className="choose-your-side-svg" />
        </div>
      </div>*/}

      {/*<div className="bear-bull-nav-right-side">
        <div
          onClick={() => {
            setIsSoundEnabled(!isSoundEnabled);
          }}
          className="volume-button-wrapper"
        >
          {isSoundEnabled ? <VolumeOn /> : <VolumeOff />}
        </div>

        <div className="connect-wallet-bear-bull-game">
          <ConnectWallet />
        </div>
      </div>*/}
    </div>

  );
};

export default NavBar;
